export default {
  LOCAL: 'local',
  GOOGLE: 'google'
};